import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 46px;
  margin-top: 20px;
  padding-bottom: 20px;
`;

export const LogoPlataform = styled.div`
  background-image: url(${(props) => props.image || ''});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 50px;
  height: 50px;
`;

export const DivText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  margin-left: 10px;
  margin-right: auto;
  text-align: left;
  font: normal normal normal 16px/18px Source Sans Pro;
  letter-spacing: 0px;
  color: #424242;
`;

export const CustomDeleteButton = styled.button`
  background: transparent;
  border: none;
  cursor: ${(props) => (props.disable ? 'auto' : 'pointer')};
  outline: none;
  margin-left: 15px;
  color: ${(props) => (props.disable ? '#424242' : 'red')};
`;
